
const MenuChocolateIcon = () => {
    return (
        <svg className="h-8" width="184" height="108" viewBox="0 0 184 108" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="15" fill="url(#paint0_linear_64_13)" />
            <rect x="72" width="40" height="40" rx="15" fill="url(#paint1_linear_64_13)" />
            <rect x="144" width="40" height="40" rx="15" fill="url(#paint2_linear_64_13)" />
            <rect y="68" width="40" height="40" rx="15" fill="url(#paint3_linear_64_13)" />
            <rect x="72" y="68" width="40" height="40" rx="15" fill="url(#paint4_linear_64_13)" />
            <rect x="144" y="68" width="40" height="40" rx="15" fill="url(#paint5_linear_64_13)" />
            <defs>
                <linearGradient id="paint0_linear_64_13" x1="11.7391" y1="-6.29629" x2="71.6139" y2="55.0481" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#2264ED" />
                    <stop offset="1" stop-color="#3462C1" />
                </linearGradient>
                <linearGradient id="paint1_linear_64_13" x1="83.7391" y1="-6.29629" x2="143.614" y2="55.0481" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#2264ED" />
                    <stop offset="1" stop-color="#3462C1" />
                </linearGradient>
                <linearGradient id="paint2_linear_64_13" x1="155.739" y1="-6.29629" x2="215.614" y2="55.0481" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#2264ED" />
                    <stop offset="1" stop-color="#3462C1" />
                </linearGradient>
                <linearGradient id="paint3_linear_64_13" x1="11.7391" y1="61.7037" x2="71.6139" y2="123.048" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#2264ED" />
                    <stop offset="1" stop-color="#3462C1" />
                </linearGradient>
                <linearGradient id="paint4_linear_64_13" x1="83.7391" y1="61.7037" x2="143.614" y2="123.048" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#2264ED" />
                    <stop offset="1" stop-color="#3462C1" />
                </linearGradient>
                <linearGradient id="paint5_linear_64_13" x1="155.739" y1="61.7037" x2="215.614" y2="123.048" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#2264ED" />
                    <stop offset="1" stop-color="#3462C1" />
                </linearGradient>
            </defs>
        </svg>
    )
}

const MinimizeIcon = () => {
    return (
        <svg className="h-5" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_66_14)">
                <path d="M160.313 78.75H109.688C105.012 78.75 101.25 74.9883 101.25 70.3125V19.6875C101.25 16.2773 103.289 13.1836 106.453 11.8828C109.617 10.582 113.238 11.2852 115.664 13.7109L129.727 27.7734L155.496 2.00391C156.797 0.703125 158.52 0 160.313 0C162.105 0 163.828 0.703125 165.129 2.00391L178.031 14.9063C179.297 16.1719 180 17.8945 180 19.6875C180 21.4805 179.297 23.2031 177.996 24.5039L152.227 50.2734L166.289 64.3359C168.715 66.7617 169.418 70.3828 168.117 73.5469C166.816 76.7109 163.723 78.75 160.313 78.75ZM160.313 101.25C163.723 101.25 166.816 103.289 168.117 106.453C169.418 109.617 168.715 113.238 166.289 115.664L152.227 129.727L178.031 155.531C179.297 156.797 180.035 158.52 180.035 160.348C180.035 162.176 179.332 163.863 178.031 165.164L165.129 178.066C163.828 179.297 162.105 180 160.313 180C158.52 180 156.797 179.297 155.496 177.996L129.727 152.227L115.664 166.289C113.238 168.715 109.617 169.418 106.453 168.117C103.289 166.816 101.25 163.723 101.25 160.312V109.688C101.25 105.012 105.012 101.25 109.688 101.25H160.313ZM70.3125 101.25C74.9883 101.25 78.75 105.012 78.75 109.688V160.312C78.75 163.723 76.7109 166.816 73.5469 168.117C70.3828 169.418 66.7617 168.715 64.3359 166.289L50.2734 152.227L24.5039 177.996C23.2031 179.297 21.4805 180 19.6875 180C17.8945 180 16.1719 179.297 14.8711 177.996L2.00391 165.129C0.703125 163.828 0 162.105 0 160.312C0 158.52 0.703125 156.797 2.00391 155.496L27.7734 129.727L13.7109 115.664C11.2852 113.238 10.582 109.617 11.8828 106.453C13.1836 103.289 16.2773 101.25 19.6875 101.25H70.3125ZM19.6875 78.75C16.2773 78.75 13.1836 76.7109 11.8828 73.5469C10.582 70.3828 11.2852 66.7617 13.7109 64.3359L27.7734 50.2734L2.00391 24.5039C0.703125 23.2031 0 21.4805 0 19.6875C0 17.8945 0.703125 16.1719 2.00391 14.8711L14.8711 2.00391C16.1719 0.703125 17.8945 0 19.6875 0C21.4805 0 23.2031 0.703125 24.5039 2.00391L50.2734 27.7734L64.3359 13.7109C66.7617 11.2852 70.3828 10.582 73.5469 11.8828C76.7109 13.1836 78.75 16.2773 78.75 19.6875V70.3125C78.75 74.9883 74.9883 78.75 70.3125 78.75H19.6875Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_66_14">
                    <rect width="180" height="180" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

const TickIcon = () => {
    return (
        <svg className="h-5 w-5 mx-auto" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" fill="white">
            <path d="M21 6.285l-11.16 12.733-6.84-6.018 1.319-1.49 5.341 4.686 9.865-11.196 1.475 1.285z" />
        </svg>
    )
}

const ChatIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 24 24" width="100%" fill="white">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z" />
        </svg>
    )
}

const PlusIcon = () => {
    return (
        <svg data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"></path>
        </svg>
    )
}

const HomeIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
        </svg>

    )
}

const EditIcon = () => {
    return (
        <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fill-white css-w2bhrx" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="EditNoteIcon" aria-label="fontSize medium">
            <path d="M3 10h11v2H3zm0-2h11V6H3zm0 8h7v-2H3zm15.01-3.13.71-.71c.39-.39 1.02-.39 1.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71zm-.71.71-5.3 5.3V21h2.12l5.3-5.3z">
            </path>
        </svg>
    )
}

export { MenuChocolateIcon, MinimizeIcon, TickIcon, ChatIcon, PlusIcon, HomeIcon, EditIcon }